import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  MdButtonModule, 
  MdCheckboxModule,
  MdIconModule,
  MdInputModule,
  MdCardModule,
  MdSidenavModule,
  MdMenuModule,
  MdToolbarModule,
  MdProgressSpinnerModule,
  MdListModule,
  MdTabsModule,
  MdDialogModule,
  MdSnackBarModule,
  MdTableModule,
  MdSelectModule
} from '@angular/material';

@NgModule({
  imports: [
    CommonModule,
    MdButtonModule, 
    MdCheckboxModule,
    MdIconModule,
    MdInputModule,
    MdCardModule,
    MdSidenavModule,
    MdMenuModule,
    MdToolbarModule,
    MdProgressSpinnerModule,
    MdListModule,
    MdTabsModule,
    MdDialogModule,
    MdSnackBarModule,
    MdTableModule,
    MdSelectModule
  ],
  exports : [
    MdButtonModule, 
    MdCheckboxModule,
    MdIconModule,
    MdInputModule,
    MdCardModule,
    MdSidenavModule,
    MdMenuModule,
    MdToolbarModule,
    MdProgressSpinnerModule,
    MdListModule,
    MdTabsModule,
    MdDialogModule,
    MdSnackBarModule,
    MdTableModule,
    MdSelectModule
  ],
  declarations: []
})
export class MaterialModule { }



// WEBPACK FOOTER //
// /Users/jackwoodward/Desktop/JCW Services/Huckleberry Partners/Hoxby Internal Projects/intranet/hoxbyHub/src/app/material/material.module.ts